module.exports = __webpack_public_path__ + "img/logo.00fc2bfd.png";